import React from "react"
import BreadCrumbs from "./BreadCrumbs"
import {merge} from "../../utils/util"
import {colors} from "../../utils/styles"

const wrapperStyle = {
  backgroundColor: colors.white,
  backgroundImage: "url('images/subHeaderBG.png')",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  minHeight: 50,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "20px 48px",
  boxSizing: "border-box",
  borderBottom: "1px solid " + colors.mocBorders,
}

const rowStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}

const childrenRowStyle = {
  display: "flex",
  alignItems: "center"
}

const rightStyle = {
  display: "flex",
  alignItems: "center",
  fontSize: 14,
  fontWeight: 400,
  color: colors.mocText,
  whiteSpace: "nowrap"
}

class SubHeaderPanelWrapper extends React.Component {
  renderRightContent() {
    const {subHeaderRightSideInfoText} = this.props

    if (!subHeaderRightSideInfoText) {
      return null
    }

    return (
        <div style={rightStyle}>
          {subHeaderRightSideInfoText}
        </div>
    )
  }

  render() {
    const {currentStep, children, style} = this.props

    return (
        <div style={merge(wrapperStyle, style)}>
          <div style={rowStyle}>
            <BreadCrumbs currentStep={currentStep}/>
            {this.renderRightContent()}
          </div>

          {children && (
              <div style={childrenRowStyle}>
                {children}
              </div>
          )}
        </div>
    )
  }
}

export default SubHeaderPanelWrapper
